import React from 'react';
import DrawingOptions from 'components/quote_builder_widget/DrawingOptions';

const QuoteBuilderForm = ({ theme, id, setId, drawing }) => {
  return (
    <div>
      <DrawingOptions
        theme={theme}
        id={id}
        setId={setId}
        drawing={drawing}
      />
    </div>
  );
};

export default QuoteBuilderForm;
